"use strict";
/**
 * Cash Reconciliation Types
 *
 * Shared types for the cash reconciliation system that verifies
 * QVET cash closings against actual cash and card terminal totals.
 */
Object.defineProperty(exports, "__esModule", { value: true });
